export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Holionix GmbH",
  "url": "https://holionix.com",
  "logo": "https://holionix.com/logo.png",
  "description": "Enterprise-grade AI voice agents for call centers, sales automation, and customer support.",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "DE",
    "addressLocality": "Köln",
    "addressRegion": "North Rhine-Westphalia",
    "streetAddress": "Heinrich-Pesch-Straße 3",
    "postalCode": "50739"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+49-15216724688",
    "contactType": "Sales",
  "email": "info@Holionix.com",
    "availableLanguage": ["en", "de"]
  },
  "sameAs": [
    "https://linkedin.com/company/holionix",
    "https://twitter.com/holionix"
  ]
};

export const productSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Holionix AI Voice Platform",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Cloud",
  "offers": {
    "@type": "Offer",
    "price": "Contact for pricing",
    "priceCurrency": "EUR"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "127"
  },
  "description": "Enterprise AI voice agents for automating customer service, sales, and support operations."
};

export const faqSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});
